import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },

    // PRODUCTS
    {
        id: 3,
        label: 'Employees',
        icon: 'ri-shopping-bag-3-line',
        link: '/employees/list',
    },

    // =====================================
    // STOCK
    // =====================================

    {
        id: 4,
        label: 'Manage Attendance',
        icon: 'ri-calendar-check-line',
        subItems: [
            {
                id: 5,
                label: 'Attendance List',
                link: '/attendance/list',
                parentId: 4,
            },
            {
                id: 6,
                label: 'Generate QR Code',
                link: '/attendance/qr',
                parentId: 4,
            },
            {
                id: 6,
                label: 'Mark Attendance',
                link: '/attendance/mark',
                parentId: 4,
            },
        ],
    },


    {
        id: 7,
        label: 'MENUITEMS.CALENDAR.TEXT',
        icon: 'ri-calendar-2-line',
        link: '/calendar'
    },
];
